import { Box, Fade, Stack } from "@mui/material";
import React from "react";

import { Add, LineAxis } from "@mui/icons-material";
import IconButtonWithLabel from "../../IconButtonWithLabel";

const ToolbarDesignerDefault = ({ open, onCreate, onCreateLine }) => {
  return (
    <Fade in={open} timeout={500}>
      <Box
        style={{
          display: "flex",
          position: "fixed",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-end",
          pointerEvents: "none",
          padding: "24px",
          bottom: 0,
          left: 0,
          right: 0,
        }}
      >
        <Box
          style={{
            maxWidth: "100%",
            display: "flex",
            flexDirection: "row",
            pointerEvents: "auto",
            WebkitUserSelect: "none",
            background: "rgb(255,255,255)",
            boxSizing: "border-box",
            boxShadow:
              "0 0 0 1px #0000001a, 0 3px 16px #00000014, 0 2px 6px 1px #00000017",
            borderRadius: "14px",
            position: "relative",
            alignSelf: "center",
          }}
        >
          <Box
            style={{
              position: "relative",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Stack direction={"row"}>
              {/* Delete */}
              <Box onClick={onCreate}>
                <IconButtonWithLabel label="Polygon" icon={<Add />} />
              </Box>
              {/* Add */}
              <Box onClick={onCreateLine}>
                <IconButtonWithLabel label="Line" icon={<LineAxis />} />
              </Box>
            </Stack>
          </Box>
        </Box>
      </Box>
    </Fade>
  );
};

export default ToolbarDesignerDefault;
